/**
 * Navigation Operation Grouping Rules
 * Handles grouping for view changes and navigation operations
 */

import { Operation, UIOperation } from '@/shared/types/projectData';
import { GroupingRule } from './transformRules';

export const navigateRules: Record<string, GroupingRule> = {
  // View switching
  'view-change': {
    opensGroup: 'navigate',
    name: (op: Operation) => {
      const uiOp = op as UIOperation;
      const after = uiOp.details?.after as Record<string, unknown> | undefined;
      const view = after?.activeView;
      return `Switch to ${view} view`;
    },
    mergeWindow: 1000
  },

  // View mode changes
  'view-mode-change': {
    opensGroup: 'navigate',
    name: (op: Operation) => {
      const uiOp = op as UIOperation;
      const after = uiOp.details?.after as Record<string, unknown> | undefined;
      const mode = after?.isCompactView ? 'compact' : 'normal';
      return `Switch to ${mode} view`;
    },
    mergeWindow: 1000
  }
};
